module.exports = __webpack_public_path__ + "media/12_11.ba2d08db.wav";